<template>
  <div v-loading="loading" class="card_errors_block">
    <el-tag
      class="error_tag"
      style="margin: 5px 10px 5px 0;"
      :closable="false"
      type="danger"
      effect="dark"
      v-for="(error, index) in errors"
      :key="index"
    >
      <i :class="$companyConfiguration.card.getErrorsIcon()"></i> {{ error.errorText }}
    </el-tag>
    <el-tag
      style="margin: 5px 5px 5px 0"
      :closable="false"
      type="warning"
      v-for="(error, index) in warnings"
      :key="'warning'+index"
    >

      {{ error.errorText }}
    </el-tag>
  </div>
</template>

<script>

import {mapGetters} from "vuex";

export default {
  name: "card-errors",
  components: {},

  props: {
    card: {type: Object, required: true},
  },

  computed: {
    ...mapGetters('card/errors', {
      loading: 'loading',
      errors: 'errors',
      warnings: 'warnings',
    }),
  },
  mounted() {
    this.$store.dispatch('card/errors/loadErrors');
  },
  created() {
    this.unsubscribe = this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'card/updateCard') {
        this.$store.dispatch('card/errors/loadErrors');
      }
    });
  },
  beforeDestroy() {
    this.unsubscribe();
  },
  data() {
    return {
      // loading: false,

      // errors: [],
    }
  },

  methods: {}
}
</script>

<style>

</style>